import { useState } from 'react';
import { useEventListener } from '../useEventListener';
import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect';
const IS_SERVER = typeof window === 'undefined';
export function useWindowSize(options = {}) {
    let { initializeWithValue = true } = options;
    if (IS_SERVER) {
        initializeWithValue = false;
    }
    const [windowSize, setWindowSize] = useState(() => {
        if (initializeWithValue) {
            return {
                width: window.innerWidth,
                height: window.innerHeight,
            };
        }
        return undefined;
    });
    const handleSize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, []);
    return windowSize;
}
